import handZone from 'assets/images/elearning/disinfection-and-washing/hand-zone.png';
import howToDisinfection from 'assets/images/elearning/disinfection-and-washing/how-to-disinfection-2026.png';
import videoCover from 'assets/images/elearning/disinfection-and-washing/video-cover-2026.png';
import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import { Box } from 'components/universal/box';
import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import { VideoEmbed } from 'components/universal/video-embed';
import { VIDEOS } from 'constants/external-urls';
import { useTopic } from 'hooks/useTopic';
import { useTranslation } from 'react-i18next';
import { getMediaLanguage } from 'utils/language';
import cls from './proper-hand-disinfection.module.scss';

export const ProperHandDisinfection = () => {
    const { t, i18n } = useTranslation('', {
        keyPrefix:
            'elearning.handHygiene.handDisinfectionAndWashing.properHandDisinfection',
    });
    const { tasks, correctAnswer, isAnswerChecked } = useTopic();

    return (
        <div className='container'>
            <Heading className="mb-5" headingLevel="h1" headingStyle="h2a">
                {t('title1')}
            </Heading>

            <div className={cls.boxShadow}>
                <Box className={`${cls.box1} boxQuestion boxQuestion-with-padding`}>
                    <Paragraph className={cls.paragraph} fontWeight={700}>{t('title3')}</Paragraph>
                    <img src={howToDisinfection} alt="how-to-disinfection" />
                </Box>
                <Box className={`${cls.box2} boxQuestion boxQuestion-with-padding`}>
                    <Paragraph className={cls.paragraph} fontWeight={700}>{t('videoTitle')}</Paragraph>
                    <VideoEmbed
                        className={cls.video} 
                        src={
                            VIDEOS[getMediaLanguage(i18n.language)].ELEARNING
                                .PROPER_HAND_DISINFECTION
                        }
                        controls
                        poster={videoCover}
                    />
                </Box>
            </div>

            <TasksGenerator
                tasks={tasks}
                isChecked={isAnswerChecked}
                correctAnswer={correctAnswer}
                isQuiz={false}
            />
            
            <Box className={`${cls.box3} boxQuestion boxQuestion-with-padding`}>
                <Paragraph className={cls.paragraph} fontWeight={700}>{t('title4')}</Paragraph>
                <Paragraph className={cls.paragraph}>{t('description')}</Paragraph>
                <img src={handZone} alt="hand-zone" />
            </Box>
        </div>
    );
};
